(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fw-audience-nav"] && !Shopify.designMode) return;
  try {
    (function(){
  function closeAudienceExcept(target){
    document.querySelectorAll('.fw-audience-nav details[open]').forEach(function(details){
      if(!details.parentElement.contains(target)) details.open=false;
    });
  }
  document.addEventListener('pointerover',function(event){if(event.pointerType!=='touch')closeAudienceExcept(event.target);});
  document.addEventListener('focusin',function(event){closeAudienceExcept(event.target);});
  document.addEventListener('click',function(event){closeAudienceExcept(event.target);});
  document.addEventListener('keydown',function(event){
    if(event.key!=='Escape')return;
    document.querySelectorAll('.fw-audience-nav details[open]').forEach(function(details){details.open=false;details.querySelector('summary').focus();});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
